import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CategoryService extends GenericService {
  constructor() {
    super('/categories', axiosInstance);
  }
}

export default new CategoryService(); 